<template>
<component v-bind:is="layout"></component>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/vue-select.css'
import AppLayout from './layouts/AppLayout'
import LoginLayout from './layouts/LoginLayout'
import GroupLayout from './layouts/GroupLayout'
import axios from 'axios'
import config from '@/config.js'
import window_note from '@/assets/js/window_note.js'
// import onesignal from '@/onesignal.js'

// TODO сделать проверку на версию APP и принудительно перезагружать в случае отличия
export default {
  name: 'App',
  mounted() {
    checkLogin(this)
  },
  computed: {
    layout() {
      return this.$store.getters.layout
    }
  },
  components: {
    'app-layout': AppLayout,
    'login-layout': LoginLayout,
    'group-layout': GroupLayout
  },
  
}

function checkLogin(vue_obj) {
  if (!!localStorage.token) {
    var data = new FormData()
    data.set('token', localStorage.token)
    axios({
        method: 'POST',
        url: config.API_HOST + '/user/check-user',
        data: data
      })
      .then(function (response) {
        console.log('is login')
        // onesignal.start()
      })
      .catch(function (error) {
        delete localStorage.token
        location.reload()
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue